
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1502_NDialog extends Serenity.EntityDialog<Report_1502_NRow, any> {
        protected getFormKey() { return Report_1502_NForm.formKey; }
        protected getIdProperty() { return Report_1502_NRow.idProperty; }
        protected getLocalTextPrefix() { return Report_1502_NRow.localTextPrefix; }
        protected getNameProperty() { return Report_1502_NRow.nameProperty; }
        protected getService() { return Report_1502_NService.baseUrl; }
        protected getDeletePermission() { return Report_1502_NRow.deletePermission; }
        protected getInsertPermission() { return Report_1502_NRow.insertPermission; }
        protected getUpdatePermission() { return Report_1502_NRow.updatePermission; }

        protected form = new Report_1502_NForm(this.idPrefix);

    }
}